import axios from 'axios';

// Always send cookies (important for CSRF)
axios.defaults.withCredentials = true;

let csrfToken = null;

// This function fetches the token and sets it as a default header
export async function fetchCsrfToken() {
  try {
    const response = await axios.get('/api/csrf-token');
    csrfToken = response.data.csrfToken;
    // Set the token as the default header for all future requests
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken;
    console.log('✅ CSRF token fetched and set');
    return csrfToken;
  } catch (error) {
    console.error('Failed to fetch CSRF token:', error);
    return null;
  }
}

// Export the configured axios instance (optional, but you can just use axios directly)
export default axios;